import React, { useState } from 'react';
import { createSearchParams, useLocation, useParams } from 'react-router-dom';
import TabsPanel from 'components/tabs/TabsPanel';
import SimpleLoader from 'components/loader/SimpleLoader';
import { BackButton } from 'components/buttons';
import Header, { ButtonConfig } from 'components/header/Header';
import { ShareOverview } from './components';
import RequestDetails from './components/RequestDetails';
import useRequestStatusRole from './hooks/useRequestStatusRole';
import DatasetInformation from './components/DatasetInformation';
import { NStatusTag } from '@innersource-nn/novoui-react';
import { getTagColor } from 'utils/getTagColorForShare';
import DeleteModal from 'components/modal/DeleteModal';
import useRemoveShareObject from './hooks/useRemoveShareObject';

const ShareView = () => {
    const params = useParams();
    const shareUri = params.uri;
    const [deleteModalOpen, setDeleteModalOpen] = useState(false);
    const [counter, setCounter] = useState(1);
    const location = useLocation();
    const activeTab = createSearchParams(location.search).get('tab');

    const { role, status, created, loading, error } = useRequestStatusRole();
    const { removeShareObject, removeLoading } = useRemoveShareObject();

    const buttonConfigs: ButtonConfig[] = [
        {
            label: 'Delete',
            onClick: () => setDeleteModalOpen(true),
            icon: 'trash',
            red: true,
        },
    ];

    return (
        <div>
            <BackButton counter={counter} />
            {loading ? (
                <SimpleLoader />
            ) : (
                !error && (
                    <div>
                        <DeleteModal
                            title="Delete share request"
                            type="share request"
                            onClick={removeShareObject}
                            loading={removeLoading}
                            visible={deleteModalOpen}
                            onClose={() => setDeleteModalOpen(false)}
                        />
                        <Header
                            title={`Share Request: ${shareUri}`}
                            buttonConfigs={buttonConfigs}
                        />
                        <div className="flex items-center gap-8">
                            <div className="text-true-blue text-sm">
                                Created: {created}
                            </div>
                            <NStatusTag
                                label={role}
                                variant="rounded"
                                icon="person"
                            />
                            <NStatusTag
                                label={status}
                                state={getTagColor(status)}
                            />
                        </div>
                        <TabsPanel
                            counter={counter}
                            setCounter={setCounter}
                            tabs={[
                                {
                                    label: 'Overview',
                                    component: <ShareOverview />,
                                },
                                {
                                    label: 'Dataset Information',
                                    component: <DatasetInformation />,
                                },
                            ]}
                        />
                        {activeTab !== '1' && (
                            <RequestDetails role={role} status={status} />
                        )}
                    </div>
                )
            )}
        </div>
    );
};

export default ShareView;
